import Paper from '@mui/material/Paper'
import React from 'react'
import ThumbsUp from '../../images/ThumbsUp.svg'
import ThumbsDown from '../../images/ThumbsDown.svg'
import { useMixpanel } from '../../mixpanel-hook/mixpanel-context'
import * as S from './styles'
import * as SS from '../../organisms/result/styles.js'
import { SmoothImage} from '../../atoms/SmoothImageLoad'

const whatsappLink = "https://api.whatsapp.com/send?phone=5548998286828&text=Ol%C3%A1!%20Quero%20uma%20vida%20financeira%20tranquila%2C%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20Monefica!"

const PositiveDescription = ({mixpanel, handleClickConversionDialogOpen }) => <Paper style={{
	padding: '20px 16px ',
	margin: 20,
	maxWidth: 900
}}>
	<SS.Row>
		<div style={{height: 40, width: 40}}>
			<SmoothImage src={ThumbsUp} height={40} width={40}/>
		</div>
		<SS.Text style={{ paddingLeft: 12, lineHeight: '1.4em'  }}>
			<strong>PARABÉNS!</strong> Você está no caminho certo, agora é se controlar para manter o plano. O Monefica te ajuda a acompanhar esse percurso.
			<br/><br/>
			<strong>Quer ficar atento as oportunidades de antecipar ou aumentar sua aposentadoria?</strong>
		</SS.Text>
	</SS.Row>
	<SS.Row>
		<S.CenteredButton onClick={() => {
			window.open(whatsappLink, '_blank');
			mixpanel.track("Solicitou o contato por whatsapp", {resultado: 'positivo'})
		}} variant="contained" color="primary">SIM! pelo whatsapp!</S.CenteredButton>
		<S.CenteredButton onClick={() => {
			alert("Nosso consultor entrará em contato em breve!")
			mixpanel.track("Solicitou o contato por email", {resultado: 'positivo'})
		}} variant="contained" color="primary">SIM! por email!</S.CenteredButton>
	</SS.Row>
</Paper>

const NegativeDescription = ({ handleClickConversionDialogOpen, mixpanel }) => <Paper style={{
	padding: '20px 16px ',
	margin: 20,
	maxWidth: 900
}}>
	<SS.Row>
		<div style={{height: 40, width: 40}}>
			<SmoothImage src={ThumbsDown} height={40} width={40}/>
		</div>
		<SS.Text style={{ paddingLeft: 12, lineHeight: '1.4em' }}>
			<strong>Opa!</strong> Seu plano tributário para 2022 pode ser melhorado com uma previdência PGBL.
			<br/><br/>
			<strong>Quer uma análise mais detalhada para melhorar esse plano?</strong>
		</SS.Text>
	</SS.Row>
	<SS.Row>
		<S.CenteredButton onClick={() => {
			window.open(whatsappLink, '_blank');
			mixpanel.track("Solicitou o contato por whatsapp", {resultado: 'negativo'})
		}} variant="contained" color="primary">SIM! por whatsapp!</S.CenteredButton>
		<S.CenteredButton onClick={() => {
			alert("Nosso consultor entrará em contato em breve!")
			mixpanel.track("Solicitou o contato por email", {resultado: 'negativo'})
		}} variant="contained" color="primary">SIM! por email!</S.CenteredButton>
	</SS.Row>
</Paper>

export function ResultDescription({initialResult, handleClickConversionDialogOpen}) {
	const mixpanel = useMixpanel()

	const descriptionResult = initialResult.withSupplementaryPensionMaximum.fiscalGainFromUser > 0
	return (<SS.Container>
		<div>
			{descriptionResult ?
				<NegativeDescription handleClickConversionDialogOpen={handleClickConversionDialogOpen} mixpanel={mixpanel}/> :
				<PositiveDescription handleClickConversionDialogOpen={handleClickConversionDialogOpen} mixpanel={mixpanel}/>
				}
		</div>
	</SS.Container>)
}
